/**
 * aiAnalystSession - RETIRED.
 *
 * Personal-Analyst chat history now lives on the SERVER (see utils/conversationsApi
 * and the /api/conversations endpoints) so it survives a hard refresh and re-login.
 * The old sessionStorage-backed store was wiped on refresh and on logout.
 *
 * These exports are kept as thin no-op stubs ONLY because other modules still
 * import them (notably AuthContext imports clearAIAnalystSessionOnReload and
 * clearAIAnalystSession; that call site is removed separately). They intentionally
 * touch no storage and return safe empty defaults. Do NOT reintroduce
 * sessionStorage persistence here.
 */

const noop = () => {};

export const createChatId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const normalizeChatRecord = (chat) => chat || {};

export const getChatHistory = () => [];
export const setChatHistory = noop;

export const getCurrentChatId = () => null;
export const setCurrentChatId = noop;

export const getChatMessagesKey = (chatId) => `aiAnalystChatMessages:${chatId}`;
export const getChatMessages = () => [];
export const setChatMessages = noop;
export const deleteChatMessages = noop;

export const getChatInputDraft = () => "";
export const setChatInputDraft = noop;

export const getStoredAttachments = () => [];
export const setStoredAttachments = noop;

export const getActivity = () => [];
export const setActivity = noop;

export const createChatRecord = (chatId) => ({ id: chatId });
export const upsertChatRecord = () => [];
export const deleteChatRecord = () => [];

export const clearAIAnalystSession = noop;
export const clearAIAnalystSessionOnReload = noop;

export const buildShortChatTitle = (...candidates) =>
  candidates.find((v) => typeof v === "string" && v.trim().length > 0) || "New Chat";
